import { _ as r } from "./index.es402.js";
import { _ as o } from "./index.es403.js";
import { _ as p } from "./index.es404.js";
var i = r, e = o, a = p, s = a && a.isMap, t = s ? e(s) : i, n = t;
export {
  n as i
};
//# sourceMappingURL=index.es267.js.map
